/*
 * Aviso de pais e idioma.
 *
 * El marcado llega siempre y oculto dentro de la pagina cacheada, porque la cache de WP
 * Rocket es la misma para todo visitante y no sabe de que pais viene. Asi que la decision
 * de mostrarlo se toma aqui, en el navegador, con el pais que resuelve window.scVisitorCountry
 * (location-access-control.php): la cookie si ya existe, o el servidor si aun no.
 */

const readCookie = (name) => {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.*+?^${}()|[\]\\])/g, '\\$1') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
};

const writeCookie = (name, value) => {
    const oneYearInSeconds = 60 * 60 * 24 * 365;
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${oneYearInSeconds}; SameSite=Lax`;
};

const init = async () => {
    const root = document.getElementById('sc-locale-suggestion');

    if (!root) {
        return;
    }

    let config;

    try {
        config = JSON.parse(root.dataset.config || '{}');
    } catch (error) {
        return;
    }

    const country = window.scVisitorCountry
        ? await window.scVisitorCountry
        : readCookie(config.countryCookie);

    /* Sin pais no hay nada que sugerir: o la geolocalizacion aun no ha corrido o no ha
       sabido resolver la IP. Callar es mejor que preguntar a ciegas. */
    if (!country) {
        return;
    }

    // Ya dijo que no para este pais concreto; si viaja y cambia, vuelve a tener sentido preguntar
    if (readCookie(config.dismissCookie) === country) {
        return;
    }

    const suggestedLanguage = (config.spanishCountries || []).includes(country) ? 'es' : 'en';

    /* En la web global, al visitante de un pais UL se le pregunta aunque ya este en su idioma:
       confirmar el pais es lo que le lleva a la web de USA (sc_handle_country_selection). */
    const goesToUsa = (config.usaCountries || []).includes(country);

    if (suggestedLanguage === config.currentLanguage && !goesToUsa) {
        return;
    }

    const box = root.querySelector('.sc-locale-suggestion__box');
    const countrySelect = root.querySelector('[data-field="country"]');
    const languageSelect = root.querySelector('[data-field="language"]');
    const form = root.querySelector('form');

    if (!box || !countrySelect || !languageSelect || !form) {
        return;
    }

    // Solo se preselecciona si el pais existe en la lista de WooCommerce; si no, se deja el primero
    if (countrySelect.querySelector(`option[value="${CSS.escape(country)}"]`)) {
        countrySelect.value = country;
    }

    const suggestedOption = languageSelect.querySelector(`option[data-code="${CSS.escape(suggestedLanguage)}"]`);

    if (suggestedOption) {
        languageSelect.value = suggestedOption.value;
    }

    const dismiss = () => {
        writeCookie(config.dismissCookie, country);
        root.remove();
        document.removeEventListener('keydown', onKeydown);
        document.removeEventListener('click', onClickOutside);
        consentBannerBodyObserver.disconnect();

        if (bannerAttributesObserver) {
            bannerAttributesObserver.disconnect();
        }
    };

    /* root.hidden puede alternar mientras espera al banner de cookies (ver mas abajo): sin
       este guardado, Escape o un clic fuera cerrarian para siempre un aviso que el visitante
       ni siquiera ha llegado a ver todavia. */
    let revealedAt = 0;

    /* Solo cuentan los eventos posteriores al momento en que el aviso se hizo visible. El clic
       que cierra el banner de cookies (Solo imprescindibles, la X...) lo trata Complianz
       antes que este listener, y los MutationObserver se resuelven entre listener y listener:
       cuando este clic nos llega, el aviso ya se ha revelado y el banner ya no esta pendiente,
       asi que se tomaba por un clic fuera y descartaba el aviso para siempre. */
    const happenedAfterReveal = (event) => event.timeStamp > revealedAt;

    const onKeydown = (event) => {
        if (!root.hidden && event.key === 'Escape' && happenedAfterReveal(event)) {
            dismiss();
        }
    };

    /* Se mira la caja y no la raiz: la raiz es el fondo oscuro que cubre la pantalla, asi
       que clicar fuera cae dentro de ella y no cerraria nunca. Se repite aqui el chequeo del
       banner de cookies (no solo en reactToBannerState): en el margen de tiempo entre que el
       banner se revela de verdad y el observer de abajo se entera y oculta este aviso, ambos
       pueden estar pintados a la vez, y un clic pensado para "Aceptar" del banner de cookies
       tambien cae "fuera de la caja" de este aviso y lo descartaria para siempre sin que el
       visitante lo pidiera. */
    const onClickOutside = (event) => {
        if (!root.hidden && !box.contains(event.target) && happenedAfterReveal(event) && !isConsentBannerVisible()) {
            dismiss();
        }
    };

    form.addEventListener('submit', (event) => {
        event.preventDefault();

        /* Si el idioma elegido no es el que la sugerencia automatica habria puesto para este
           pais (p. ej. el visitante prefiere quedarse en un idioma distinto al de su pais),
           suggestedLanguage === currentLanguage nunca se cumple tras la recarga y el aviso
           volveria a aparecer en la pagina siguiente. Marcar aqui el descarte, igual que hace
           dismiss(), evita que una confirmacion explicita se confunda con "sigue sin resolver". */
        writeCookie(config.dismissCookie, countrySelect.value);

        /* El pais viaja en la query y lo persiste PHP, en la misma navegacion que lleva al
           idioma elegido: asi solo hay un sitio que escribe la cookie del pais. */
        const target = new URL(languageSelect.value, window.location.origin);
        target.searchParams.set(config.confirmArg, countrySelect.value);

        window.location.assign(target.toString());
    });

    let listenersAttached = false;

    const show = () => {
        if (root.hidden) {
            root.hidden = false;
            revealedAt = performance.now();
        }

        if (listenersAttached) {
            return;
        }

        listenersAttached = true;

        /* El diseno no trae aspa de cerrar, asi que la salida son las dos que el usuario ya
           espera de cualquier aviso: Escape y clic fuera. */
        document.addEventListener('keydown', onKeydown);

        // En el mismo tick el clic que abrio la pagina cerraria el aviso al instante
        window.setTimeout(() => document.addEventListener('click', onClickOutside), 0);
    };

    /* No hay ficha que confirme el marcado interno del gestor de cookies de turno (Complianz
       en produccion, otro distinto en local a fecha de este cambio), asi que no se apunta a
       una clase suya concreta salvo la que ya quedo verificada en vivo. El resto es generico
       por ARIA: cualquier gestor de consentimiento accesible se anuncia como dialog/
       alertdialog/region con "cookie" en su aria-label, y eso es lo unico que hace falta
       para no competir con el con dos avisos a la vez. */
    const consentBannerSelector = '.cmplz-cookiebanner, [role="dialog"][aria-label*="cookie" i], [role="alertdialog"][aria-label*="cookie" i], [role="region"][aria-label*="cookie" i]';

    /* Con Complianz, getClientRects() no vale como señal de "sigue pendiente": el propio
       plugin oculta su banner con `cmplz-hidden` (display:none) mientras su hoja de estilos
       todavia no ha cargado (hasta 500ms de margen, cookiebanner/js/complianz.js), y ese hueco
       es indistinguible de "ya resuelto" si solo se mira el layout. `cmplz-show`/
       `cmplz-dismissed` los fija el propio plugin de forma sincrona, sin esperar a esa hoja de
       estilos, asi que no tienen ese hueco: son la señal correcta de si el consentimiento
       sigue sin resolver. Sin esa distincion, este aviso se revelaba de mas durante ese margen
       y luego se volvia a ocultar en cuanto Complianz terminaba de pintarse (visto en vivo en
       usa.santacole.com). */
    const isConsentBannerVisible = () => {
        const cmplzBanner = document.querySelector('.cmplz-cookiebanner');

        if (cmplzBanner) {
            return cmplzBanner.classList.contains('cmplz-show');
        }

        const genericBanner = document.querySelector('[role="dialog"][aria-label*="cookie" i], [role="alertdialog"][aria-label*="cookie" i], [role="region"][aria-label*="cookie" i]');
        return !!genericBanner && genericBanner.getClientRects().length > 0;
    };

    /* Se mantiene la visibilidad sincronizada durante toda la vida del aviso, no solo al
       decidir una vez al arrancar: el banner de cookies (Complianz en produccion) suele
       inyectar su marcado por JS propio, sin un momento fijo en el que ya se sepa si va a
       aparecer o no. Un timeout fijo no vale porque el TTFB local es muy variable y a veces
       extremo, muy por encima de cualquier margen razonable; en produccion la latencia real
       del script del banner tampoco esta acotada. Sin banner de cookies de
       por medio esto no cambia nada respecto al comportamiento anterior: se revela al
       primer chequeo, sincrono, igual que antes. */
    let bannerAttributesObserver = null;

    const reactToBannerState = () => {
        if (isConsentBannerVisible()) {
            root.hidden = true;
        } else {
            show();
        }
    };

    /* Solo se observan atributos del banner en si, no de toda la pagina: la home usa GSAP
       para animaciones que tocan el estilo de medio DOM en bucle, y observar style/class en
       document.body entero con subtree cuelga la pestaña (visto en vivo). childList en body
       basta para enterarse de cuando el banner se inserta o se elimina del todo. */
    const consentBannerBodyObserver = new MutationObserver(() => {
        const banner = document.querySelector(consentBannerSelector);

        if (banner && !bannerAttributesObserver) {
            bannerAttributesObserver = new MutationObserver(reactToBannerState);
            bannerAttributesObserver.observe(banner, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
        }

        reactToBannerState();
    });

    consentBannerBodyObserver.observe(document.body, { childList: true, subtree: true });

    const initialBanner = document.querySelector(consentBannerSelector);

    if (initialBanner) {
        bannerAttributesObserver = new MutationObserver(reactToBannerState);
        bannerAttributesObserver.observe(initialBanner, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    }

    reactToBannerState();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
